{
    "APP_IFRAME_START_LOADING": {
        "eventId": 642,
        "src": 42,
        "params": {
            "widget_id": "widgetId",
            "widget_name": "widgetName",
            "instance_id": "compId",
            "appId": "appDefinitionId",
            "loading_time": "loadingTime",
            "pid": "pageId",
            "pn": "pageNo",
            "iss": "ssr",
            "tts": "totalLoadingTime",
            "external_app_id": "externalAppDefinitionId",
            "external_widget_id": "externalWidgetId",
            "lazy_load": "lazyLoad"
        },
        "sampleRatio": 1
    },
    "APP_LOADED_SUCCESSFULLY": {
        "eventId": 643,
        "src": 42,
        "params": {
            "widget_id": "widgetId",
            "instance_id": "compId",
            "appId": "appDefinitionId",
            "loading_time": "loadingTime",
            "pid": "pageId",
            "pn": "pageNo",
            "iss": "ssr",
            "tts": "totalLoadingTime",
            "external_app_id": "externalAppDefinitionId",
            "external_widget_id": "externalWidgetId"
        },
        "sampleRatio": 1
    },
    "APP_LOADED_PARTIALLY": {
        "eventId": 644,
        "src": 42,
        "params": {
            "widget_id": "widgetId",
            "instance_id": "compId",
            "appId": "appDefinitionId",
            "loading_time": "loadingTime",
            "stage": "stage",
            "stage_number": "stageNum",
            "pid": "pageId",
            "pn": "pageNo",
            "iss": "ssr",
            "tts": "totalLoadingTime",
            "external_app_id": "externalAppDefinitionId",
            "external_widget_id": "externalWidgetId"
        }
    },
    "APP_SDK_START_LOADING": {
        "eventId": 645,
        "src": 42,
        "params": {
            "widget_id": "widgetId",
            "instance_id": "compId",
            "appId": "appDefinitionId",
            "loading_time": "loadingTime",
            "pid": "pageId",
            "pn": "pageNo",
            "iss": "ssr",
            "tts": "totalLoadingTime",
            "external_app_id": "externalAppDefinitionId",
            "external_widget_id": "externalWidgetId"
        }
    },
    "FAILED_TO_LOAD_IFRAME_FROM_SSR_CACHE": {
      "eventId": 425,
      "src": 42,
      "params": {
        "widget_id": "widgetId",
        "instance_id": "compId",
        "appId": "appDefinitionId",
        "loading_time": "loadingTime",
        "pid": "pageId",
        "pn": "pageNo",
        "iss": "ssr",
        "tts": "totalLoadingTime",
        "external_app_id": "externalAppDefinitionId",
        "external_widget_id": "externalWidgetId"
      }
    }
}
